export const ARTICLES_MODAL_STATES = {
  newArticleBlock: 'newArticleBlock',
  renameArticleBlock: 'renameArticleBlock',
  deleteArticleBlock: 'deleteArticleBlock',

  newArticle: 'newArticle',
  deleteArticle: 'deleteArticle',
};
